import classNames from 'classnames';

import ImageC from 'src/components/Image';
import { displayRating } from 'src/utils/func/format-number';
import useDeviceSize from 'src/utils/hooks/useDeviceSize';

type TStarRate = {
	ratingNumber: number;
	className: string;
	type?: 'large' | 'small';
};

type TIconSize = {
	width: number;
	height: number;
};

const StarRate = ({ ratingNumber, className, type = 'small' }: TStarRate) => {
	const deviceSize = useDeviceSize();

	let iconSize: TIconSize = {
		width: 21,
		height: 21,
	};
	if (type === 'small') {
		iconSize = {
			width: deviceSize !== 'mobile' ? 21 : 19,
			height: deviceSize !== 'mobile' ? 21 : 19,
		};
	} else if (type === 'large') {
		iconSize = {
			width: deviceSize !== 'mobile' ? 43 : 32,
			height: deviceSize !== 'mobile' ? 43 : 32,
		};
	}
	return (
		<div className={classNames(className)}>
			<ImageC
				alt={'icon star'}
				width={iconSize.width}
				height={iconSize.height}
				src="/icons/icon-star.svg"
			/>
			{displayRating(ratingNumber, 1)}/5
		</div>
	);
};

export default StarRate;
